import { AuthGuard } from '@onesource/components';
import { createFileRoute } from '@tanstack/react-router';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { SubscriptionDetailPage } from 'src/pages/billing/subscription-detail';

export const Route = createFileRoute('/subscriptions/$subscriptionNo')({
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <SubscriptionDetailPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
